import { Routes } from '@angular/router';
import { SearchComponent } from './search/search.component';
import { RegistrationComponent } from './registration/registration.component';
import { LicenseRegistrationComponent } from './license-registration/license-registration.component';
import { AuthGuard } from './auth.guard';
import { LoginComponent } from './login/login.component';
import { RequestDemoComponent } from './request-demo/request-demo.component';
import { UserListComponent } from './user-list/user-list.component';
import { TestReportComponent } from './test-report/test-report.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'search',
    pathMatch: 'full',
  },
  {
    path: 'main',
    component: LoginComponent,
  },
  {
    path: 'request-demo',
    component: RequestDemoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'test-report',
    component: TestReportComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'search',
    component: SearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'registration',
    component: RegistrationComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'user-list',
    component: UserListComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'license',
    component: LicenseRegistrationComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'bug-report',
    // @ts-ignore
    loadChildren: () => import('./bug-report/bug-report.module')
      .then(mod => mod.BugReportModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'modules',
    // @ts-ignore
    loadChildren: () => import('./modules/modules.module')
      .then(mod => mod.ModulesModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'tariffs',
    // @ts-ignore
    loadChildren: () => import('./tariffs/tariffs.module')
      .then(mod => mod.TariffsModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'billing',
    // @ts-ignore
    loadChildren: () => import('./billing/billing.module')
      .then(mod => mod.BillingModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'organization',
    // @ts-ignore
    loadChildren: () => import('./organization/organization.module')
      .then(mod => mod.OrganizationModule),
    canActivate: [AuthGuard],
  },
];
